import React from 'react';
import DeleteCompanyModal from '../../DeleteCompanyModal';
import ManualSubscriptionModal from '../../ManualSubscriptionModal';
import { CHILD_MODALS } from '../utils/constants';

/**
 * Renders the currently requested child modal while preserving each existing close path.
 *
 * @param {object} props
 * @param {string|null} props.activeModal
 * @param {string} props.companyId
 * @param {Function} props.onCloseChildModal
 * @param {Function} props.onCloseCompanyDetails
 */
export const CompanyDetailsChildModal = ({
    activeModal = null,
    companyId,
    onCloseChildModal,
    onCloseCompanyDetails
}) => {
    switch (activeModal) {
        case CHILD_MODALS.delete:
            return <DeleteCompanyModal companyId={companyId} onClose={onCloseChildModal} />;
        case CHILD_MODALS.manualSubscription:
            return <ManualSubscriptionModal companyId={companyId} onClose={onCloseCompanyDetails} />;
        default:
            return null;
    }
};
